import {useQueries, useQuery} from 'react-query';

import {contextOrganizationId} from 'src/lib/api/api';
import {H5WeatherDataRequest, fetchH5WeatherData, fetchH5WeatherListings} from 'src/lib/api/h5';
import {Site} from 'src/lib/api/project';

// As with the forecast hooks: fetch gets react-query's signal so an unmounted section stops a read,
// and contextOrganizationId is in the key because the request sends it as a header.

export function useH5WeatherListing(
  site: Site,
  projectId: string,
  initTimeRange: [Date, Date],
  {enabled = true}: {enabled?: boolean} = {}
) {
  return useQuery(
    [
      'h5Weather',
      contextOrganizationId,
      site.id,
      projectId,
      initTimeRange[0].toISOString(),
      initTimeRange[1].toISOString(),
    ],
    ({signal}) => fetchH5WeatherListings(site.id, projectId, initTimeRange, {signal}),
    {retry: false, enabled}
  );
}

// One read per resource, in the order of `requests`.
export function useH5WeatherData(site: Site, requests: H5WeatherDataRequest[]) {
  return useQueries(
    requests.map((request) => ({
      queryKey: ['h5WeatherData', contextOrganizationId, site.id, request],
      queryFn: ({signal}: {signal?: AbortSignal}) => fetchH5WeatherData(site.id, request, {signal}),
      retry: false,
    }))
  );
}
